import React from 'react';

/*
 * Local, dependency-free line-icon set used across the site.
 * No icon fonts or CDN libraries – every icon is inline SVG using currentColor.
 */

const base = {
  width: 28,
  height: 28,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const IconShieldCheck = (props) => (
  <svg {...base} {...props}>
    <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

export const IconCertificate = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="8" r="5.5" />
    <path d="M9 12.5L7.5 20l4.5-2.5 4.5 2.5-1.5-7.5" />
    <path d="M9.5 8l1.8 1.8L14.5 6" />
  </svg>
);

export const IconGlobeLeaf = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3c2.5 2.5 3.5 6 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-6-3.5-9s1-6.5 3.5-9z" />
  </svg>
);

export const IconTransfer = (props) => (
  <svg {...base} {...props}>
    <path d="M4 8h13" />
    <path d="M13 4l4 4-4 4" />
    <path d="M20 16H7" />
    <path d="M11 20l-4-4 4-4" />
  </svg>
);

export const IconReport = (props) => (
  <svg {...base} {...props}>
    <path d="M6 3h9l3 3v15H6z" />
    <path d="M9 12v5" />
    <path d="M12 9v8" />
    <path d="M15 14v3" />
  </svg>
);

export const IconLeafRegs = (props) => (
  <svg {...base} {...props}>
    <path d="M5 15c-1.5-5 2-11 12-12 1 8-4 13-12 12z" />
    <path d="M5 15c2.5-2 5-4 9-9" />
  </svg>
);

export const IconCheckCircle = (props) => (
  <svg {...base} width={22} height={22} {...props}>
    <circle cx="12" cy="12" r="9.5" />
    <path d="M8 12.5l2.5 2.5L16 9.5" />
  </svg>
);

export const IconPhone = (props) => (
  <svg {...base} {...props}>
    <path d="M6 3.5h3.5l1.5 4-2 1.6a12 12 0 0 0 5.9 5.9l1.6-2 4 1.5V18a2 2 0 0 1-2 2C10.5 20 4 13.5 4 5.5a2 2 0 0 1 2-2z" />
  </svg>
);

export const IconMail = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3.5 6.5L12 13l8.5-6.5" />
  </svg>
);

export const IconLocation = (props) => (
  <svg {...base} {...props}>
    <path d="M12 21s7-6.5 7-11.5a7 7 0 0 0-14 0C5 14.5 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </svg>
);

export const IconArrowRight = (props) => (
  <svg {...base} width={18} height={18} {...props}>
    <path d="M4 12h15" />
    <path d="M13 6l6 6-6 6" />
  </svg>
);

export const IconMenu = (props) => (
  <svg {...base} {...props}>
    <path d="M4 7h16" />
    <path d="M4 12h16" />
    <path d="M4 17h16" />
  </svg>
);

export const IconClose = (props) => (
  <svg {...base} {...props}>
    <path d="M5 5l14 14" />
    <path d="M19 5L5 19" />
  </svg>
);

export const IconCompass = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9.5" />
    <path d="M15 9l-2 6-6 2 2-6z" />
  </svg>
);

export const IconTarget = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1" fill="currentColor" />
  </svg>
);

export const IconLayers = (props) => (
  <svg {...base} {...props}>
    <path d="M12 3l9 5-9 5-9-5 9-5z" />
    <path d="M3 13l9 5 9-5" />
  </svg>
);

export const IconSun = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="4.5" />
    <path d="M12 2.5v3M12 18.5v3M4.6 4.6l2.1 2.1M17.3 17.3l2.1 2.1M2.5 12h3M18.5 12h3M4.6 19.4l2.1-2.1M17.3 6.7l2.1-2.1" />
  </svg>
);

export const IconWindTurbine = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="5.2" r="1.1" fill="currentColor" />
    <path d="M12 5.2L6 9.5" />
    <path d="M12 5.2l4.8 5.6" />
    <path d="M12 5.2L10 13" />
    <path d="M11 21l2-13" />
    <path d="M9 21h6" />
  </svg>
);

export const IconBolt = (props) => (
  <svg {...base} {...props}>
    <path d="M13 2L4.5 13.5H11l-1.5 8.5L18.5 10.5H12l1-8.5z" />
  </svg>
);

export const IconRefresh = (props) => (
  <svg {...base} {...props}>
    <path d="M4 12a8 8 0 0 1 13.66-5.66L20 8" />
    <path d="M20 4v4h-4" />
    <path d="M20 12a8 8 0 0 1-13.66 5.66L4 16" />
    <path d="M4 20v-4h4" />
  </svg>
);

export const IconLeaf = (props) => (
  <svg {...base} {...props}>
    <path d="M5 15c-1.5-5 2-11 12-12 1 8-4 13-12 12z" />
    <path d="M5 15c2.5-2 5-4 9-9" />
  </svg>
);

export const IconClock = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.5 2" />
  </svg>
);
